import { IClientDigitalMenuState } from '../initialStates/digitalMenu';
import { ILocationState } from '../../../locations/redux/LocationState';
import { AppState } from '../../../redux/initialStates/AppState';

export const selectLocation = (state: AppState): ILocationState => state.location;
export const selectClientDigitalMenu = (state: AppState): IClientDigitalMenuState => state.digitalMenu;
